import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import { appConfig } from 'config/appConfig';
import okta from 'constants/okta';

const APIEndpoint = 'auth';

export const getUser = () => {
  return axios({
    method: 'get',
    url: appConfig.API_URL + '/' + APIEndpoint,
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
  })
    .then((response) => response.data)
    .catch((error) => {
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};
